import { render, staticRenderFns } from "./answers-list.vue?vue&type=template&id=f5b26994"
import script from "./answers-list.vue?vue&type=script&lang=js"
export * from "./answers-list.vue?vue&type=script&lang=js"
import style0 from "./answers-list.vue?vue&type=style&index=0&id=f5b26994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports